module.exports = __webpack_public_path__ + "img/infoSelection.a3af6bbd.svg";